import { inject, Injectable, signal } from "@angular/core";
import { AuthenticationService } from "@core/services/authentication.service";

@Injectable({providedIn: 'root'})
export class DeveloperService {
  readonly authService = inject(AuthenticationService);

  readonly #logsVisible = signal(false);
  readonly logsVisible =  this.#logsVisible.asReadonly();

  readonly #logs = signal<string[]>([]);
  readonly logs = this.#logs.asReadonly();

  addLog(logId: string, str: string) {
    this.#addLog(`${logId} - [${new Date().toISOString()}] ${str}`);
  }

  #addLog(entry: string) {
    this.#logs.update(logs => [...logs, entry]);
  }
  clearLogs() {
    this.#logs.set([]);
  }
  toggleLogs() {
    this.#logsVisible.update(v => !v);
  }
}
